/**
 *
 * WARNING : fichier généré par cli, ne pas le modifier directement
 *
 */
import { gql } from '@apollo/client';

export const FetchCountriesQuery = gql`
  query FetchCountriesQuery($search: String) {
    fetchCountries_simulation_customer_grantees(search: $search) {
      countries {
 value  
label  
}
    }
  }
`;

export default FetchCountriesQuery;
